import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

/**
 * Sanitizes and parses HTML content.
 * @param {string} htmlContent - The HTML content to sanitize and parse.
 * @returns {React.ReactNode | null} - The sanitized and parsed React nodes.
 */
export function sanitizeAndParseHtml(htmlContent) {
  try {
    const sanitizedContent = DOMPurify.sanitize(htmlContent);
    return parse(sanitizedContent);
  } catch (error) {
    console.error('Failed to sanitize and parse HTML content:', error);
    return null;
  }
}

/**
 * DOMPurify config để cho phép MathML tags
 */
const MATH_PURIFY_CONFIG = {
  ADD_TAGS: [
    'math',
    'maction',
    'maligngroup',
    'malignmark',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mlongdiv',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mscarries',
    'mscarry',
    'msgroup',
    'msline',
    'mspace',
    'msqrt',
    'msrow',
    'mstack',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'semantics',
    'annotation'
  ],
  ADD_ATTR: [
    'xmlns',
    'encoding',
    'columnalign',
    'rowspan',
    'colspan',
    'stretchy',
    'form',
    'fence',
    'separator',
    'lspace',
    'rspace',
    'display',
    'displaystyle',
    'scriptlevel',
    'mathvariant',
    'mathsize',
    'mathcolor',
    'mathbackground'
  ]
};

/**
 *
 * @param {string} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html, MATH_PURIFY_CONFIG);
}

export function autoRepairAndParseJSON(badJSON) {
  if (typeof badJSON !== 'string') return badJSON;

  let fixed = badJSON
    .replace(/\r\n/g, '\\n')
    .replace(/\r/g, '\\n')
    .replace(/\n/g, '\\n');

  fixed = fixed.replace(
    /("[^":,{}[\]]*?":\s*")([^"]*?)(?:"\s*[,\]}])/g,
    (m, start, inner) => {
      const escapedInner = inner.replace(/(?<!\\)"/g, '\\"');
      return `${start}${escapedInner}"`;
    }
  );

  try {
    return JSON.parse(fixed);
  } catch (e) {
    console.error('❌ parse vẫn lỗi:', e);
    // console.log('💬 Chuỗi sau khi sửa:', fixed);
    return null;
  }
}
